import {FileUpload} from '@shared/models/file-upload/file-upload.model';
import {
  ContactUsOrderProblemAdditionalInfo,
  ContactUsOrderProblemCategory,
  ContactUsOrderProblemSubCategory
} from "@contact-us/models/contact-us.models";

export interface ContactUs {
  topicName: Topics | null;
  visitInfo: VisitInfo | null;
  userExperience: ExperienceDetails | null;
  contactInformation: ContactDetails | null;
  problem?: ContactUsProblem | null;
}

export interface ContactUsProblem {
  problemItems: any[],
  problemImage?: FileUpload | null,
  orderEmail?: string,
  problemCategory?: ContactUsOrderProblemCategory,
  problemSubCategory?: ContactUsOrderProblemSubCategory | null,
  orderId?: string | null,
  problemEmail?: string,
  problemDate?: string,
  problemPickUpType: number | null,
  problemDetails?: string,
  problemAdditional?: ContactUsOrderProblemAdditionalInfo,
  problemReceiptNumber?: string | null,
}

export enum ProblemCategory {
  MISSINGITEM = 1,
  FOODQUALITY = 2,
  CUSTOMERSERVICE = 3,
  DELIVERYSERVICE = 4,
  OTHER = 5
}

export interface VisitInfo {
  mention: string;
  date?: Date | null;
  time?: string | null;
  pickupMethod?: string | null;
  restaurantLocation?: ContactLocationEntity | null;
  isOnlineOrder: boolean;
}

export interface ContactLocationEntity {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  // phone: string; - Do we need this ?
  locationName: string;
  nickName: string;
  unit: number;
  // longitude: number; - Do we need this ?
  // latitude: number;- Do we need this ?
}

export interface ExperienceDetails {
  experience: string;
  image?: FileUpload | null;
  accountEmail?: string | null;
  problemCategories?: string[];
}

export interface ContactDetails {
  phoneNumber: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  typeOfContact: TypeOfContact;
}

// TODO: Match the number to the api input value
export enum TypeOfContact {
  Email = 'Email',
  Phone = 'Phone',
  No = 'No'
}

// TODO: Match the number to the api input value
export enum Topics {
  Problem = 'Problem',
  Suggestion = 'Suggestion',
  Compliment = 'Compliment'
}
